import { render } from "./questionList.vue?vue&type=template&id=cd18bc56&scoped=true"
import script from "./questionList.vue?vue&type=script&lang=js"
export * from "./questionList.vue?vue&type=script&lang=js"

import "./questionList.vue?vue&type=style&index=0&id=cd18bc56&lang=less&scoped=true"
import "./questionList.vue?vue&type=style&index=1&id=cd18bc56&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd18bc56"]])

export default __exports__